import { Button as MantineButton } from '@mantine/core'

import { root } from './Button.css'

export const Button = MantineButton.extend({ classNames: { root } })
